import { getId } from '@common/utils/brandDiffsUtils';
import AddressSearchWidget from '@components/addressSearch/AddressSearchWidget';
import Icon from '@stone/ui/icon/Icon';
import classNames from 'classnames';
import React, { useRef, useState, useEffect, useLayoutEffect } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import { useTranslation } from 'react-i18next';
const StoreLocatorSrarchBox = (props) => {
    const { t } = useTranslation();
    const input = useRef(null);
    const autocomplete = useRef(null);
    const isLocked = useRef(false);
    const [predictionResult, setPredictionResult] = useState([]);
    const [itemFocused, setItemFocused] = useState(null);
    const [searchText, setSearchText] = useState('');
    const handleClickAway = () => {
        setTimeout(() => {
            setItemFocused(undefined);
            setPredictionResult([]);
        }, 300);
    };
    const hightlightedSuggestion = (sug) => {
        var _a, _b;
        if (((_a = sug.matched_substrings) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let strings = [];
            let lastoffset = 0;
            sug.matched_substrings.forEach((me) => {
                const text = sug.description.slice(lastoffset, me.offset - lastoffset);
                const matched = sug.description.slice(me.offset, me.offset + (me === null || me === void 0 ? void 0 : me.length));
                if (text)
                    strings.push(React.createElement(React.Fragment, null, text));
                if (matched)
                    strings.push(React.createElement("span", { className: "matched-text" }, matched));
                lastoffset = me.offset + (me === null || me === void 0 ? void 0 : me.length);
            });
            if (lastoffset < ((_b = sug.description) === null || _b === void 0 ? void 0 : _b.length))
                strings.push(React.createElement(React.Fragment, null, sug.description.substring(lastoffset)));
            return (React.createElement("div", null, strings.map((e, i) => (React.createElement(React.Fragment, { key: i }, e)))));
        }
        return sug.description;
    };
    const suggestionText = (sug) => {
        return hightlightedSuggestion(sug) || 'Not found';
    };
    const selectSuggestion = async (prediction) => {
        let result = await getPlace(prediction);
        props.onPlacesChanged && props.onPlacesChanged(result);
        isLocked.current = true;
        setSearchText(prediction.description);
    };
    useEffect(() => {
        autocomplete.current = new google.maps.places.AutocompleteService();
        props.onLoad(autocomplete.current);
    }, []);
    const getPlace = async (prediction) => {
        return new Promise((resolve) => {
            var _a;
            (_a = props.placeService) === null || _a === void 0 ? void 0 : _a.getDetails({ placeId: prediction.place_id }, (result, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    resolve([result]);
                }
                else {
                    resolve([]);
                }
            });
        }).then((res) => res);
    };
    useEffect(() => {
        let __timeout;
        if (isLocked.current) {
            isLocked.current = false;
            return;
        }
        if (searchText && searchText.length > 0) {
            __timeout = setTimeout(() => {
                let autocompletionrequest = {
                    input: searchText,
                    // componentRestrictions: {
                    //   country: props.country,
                    // },
                    types: ['geocode'],
                };
                autocomplete.current.getQueryPredictions(autocompletionrequest, (predictions) => {
                    setPredictionResult(predictions);
                });
            }, 500);
        }
        else {
            setPredictionResult([]);
        }
        return () => {
            clearTimeout(__timeout);
        };
    }, [searchText]);
    useLayoutEffect(() => {
        if (props.autoFocus)
            setTimeout(() => {
                var _a;
                (_a = input.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 200);
    }, [props.autoFocus]);
    useEffect(() => {
        isLocked.current = true;
        props.searchText && setSearchText(props.searchText);
    }, [props.searchText]);
    return (React.createElement(ClickAwayListener, { onClickAway: handleClickAway },
        React.createElement("div", { 
            // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
            role: "combobox", "aria-haspopup": "grid", "aria-expanded": "false", className: classNames('search-store__autocomplete', { 'show-list': props.showResultslist }) },
            React.createElement("div", { className: "search-store__searchbox" },
                React.createElement("input", { ref: input, id: "storelocator-searchbox", type: "text", role: "combobox", "aria-autocomplete": "list", "aria-controls": "autocomplete-listbox", "aria-expanded": (predictionResult === null || predictionResult === void 0 ? void 0 : predictionResult.length) > 0, "aria-activedescendant": itemFocused != undefined ? 'autocomplete-option-' + itemFocused : undefined, autoComplete: 'off', placeholder: t('storelocator.field.label'), value: searchText, onFocus: props.onInputFocus, onChange: (e) => {
                        setSearchText(e.target.value);
                    }, onKeyDown: (e) => {
                        setSearchText(e.currentTarget.value);
                        if (e.key === 'ArrowUp') {
                            e.preventDefault();
                            if (itemFocused == undefined) {
                                setItemFocused((predictionResult === null || predictionResult === void 0 ? void 0 : predictionResult.length) - 1);
                            }
                            else {
                                if (predictionResult[itemFocused - 1]) {
                                    setItemFocused(itemFocused - 1);
                                }
                                else {
                                    setItemFocused((predictionResult === null || predictionResult === void 0 ? void 0 : predictionResult.length) - 1);
                                }
                            }
                        }
                        else if (e.key === 'ArrowDown') {
                            e.preventDefault();
                            if (itemFocused == undefined) {
                                setItemFocused(0);
                            }
                            else {
                                if (predictionResult[itemFocused + 1]) {
                                    setItemFocused(itemFocused + 1);
                                }
                                else {
                                    setItemFocused(0);
                                }
                            }
                        }
                        else if (e.key === 'Tab' || e.key === 'Escape') {
                            handleClickAway();
                        }
                        else if (e.key == 'Enter') {
                            if (itemFocused != undefined) {
                                e.preventDefault();
                                selectSuggestion(predictionResult[itemFocused]);
                                handleClickAway();
                            }
                            else {
                                isLocked.current = false;
                            }
                        }
                        else {
                            isLocked.current = false;
                        }
                    }, className: classNames({ valued: !!searchText }) }),
                getId() === 'ST' && (React.createElement(React.Fragment, null, (searchText === null || searchText === void 0 ? void 0 : searchText.length) > 0 && (React.createElement("button", { onClick: () => {
                        setTimeout(() => {
                            props.onResetClick();
                        }, 200);
                        setSearchText('');
                    }, "aria-label": t('button.resetinput'), className: "search-store__dismiss-button button button--quaternary" },
                    React.createElement(Icon, { name: "close", family: "10" })))))),
            React.createElement(AddressSearchWidget, { id: "autocomplete-listbox", labbelledby: "storelocator-searchbox", 
                //filtro solo i risultati che hanno una PLACE ID associato senza il quale non si possono recuperare le informazioni
                items: predictionResult === null || predictionResult === void 0 ? void 0 : predictionResult.filter((res) => !!res.place_id), itemFocused: itemFocused, setItemFocused: (e) => setItemFocused(e), selectSuggestion: selectSuggestion, suggestionText: suggestionText }))));
};
export default StoreLocatorSrarchBox;
